import React, { useState, useEffect, forwardRef } from 'react';
import { useParams , useNavigate  } from 'react-router-dom';
import { useDispatch} from "react-redux";
import { getCompanyDetails ,updateCompanyDetailsById} from "./../../../services/global_redux/globale_actions/CompanyDetails.action"
import { getUser ,updateUserById} from "./../../../services/global_redux/globale_actions/Login.action"

import {getStates} from "./../../../services/global_redux/globale_actions/States.action";
import { getPermission } from "./../../../services/global_redux/globale_actions/Permission.action"
import { getCompanyRole ,updateRoleById } from "./../../../services/global_redux/globale_actions/Role.action"
// import second from 'first'
import Select from "react-select";
function UpdateCompanyDetails({ showSnackbar, setLoading }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { CompanyID } = useParams();
    const [preSelectedPermissions ,setPreSelectedPermissions] = useState({permissions:[]})
    const [companyDetails , setCompanyDetails] = useState({
        id:"",
        company_name: "",
        company_address: "",
        company_city: "",
        company_state: "",
        company_country: "",
        company_pincode: "",
        company_mail: "",
        company_phone: "",
        company_mobile:"",
        company_url:"",
        company_logo:"",
        states:[],
        total_clients:"",
        total_units:"",
        services:[],
        permissions:[],
        validity_start_date:"",
        validity_end_date: "",

      });
      const [State, setState] = useState([]);
      const [allPermission, setAllPermission] = useState([]);
      const [selectedStates, setSelectedStates] = useState([]);
      const [stateErrors, setStateErrors] = useState("");
      const [userErrors, setUserErrors] = useState({});
      const [permissionErrors, setPermissionErrors] = useState("");
      const [companyErrors, setCompanyErrors] = useState({});
      const [selectedSections, setSelectedSections] = useState({});
      const [selectedSubModules, setSelectedSubModules] = useState({});
      const [crudPermissions, setCrudPermissions] = useState({});
      const [selectedServices, setSelectedServices] = useState({});
      const [expandedServices, setExpandedServices] = useState({});
      const [userDetails, setUserDetails] = useState({
          user_name: "",
          user_email: "",
          role_name: "Organization Admin",
          mail_sent:'',
          auth_id:'',
      });
      const [roleId, getRoleId] = useState(0);
      const fetchcompanyDetails = async () => {
        try {
          setLoading(true);

          const fetchCompanyData = await dispatch(getCompanyDetails(CompanyID));

          if (fetchCompanyData.success === true) {
            const fetchedDataStore = fetchCompanyData.data;

            const mergedDetails = {
            //   ...fetchedDataStore,
              id: fetchedDataStore.id || "",
              company_name: fetchedDataStore.company_name || "",
              company_address: fetchedDataStore.company_address || "",
              company_city: fetchedDataStore.company_city || "",
              company_state: fetchedDataStore.company_state || "",
              company_country: fetchedDataStore.company_country || "",
              company_pincode: fetchedDataStore.company_pincode || "",
              company_mail: fetchedDataStore.company_mail || "",
              company_phone: fetchedDataStore.company_phone || "",
              company_mobile: fetchedDataStore.company_mobile || "",
              company_url: fetchedDataStore.company_url || "",
              company_logo: fetchedDataStore.company_logo || "",
              states: Array.isArray(fetchedDataStore.states)
                ? fetchedDataStore.states
                : typeof fetchedDataStore.states === "string"
                ? fetchedDataStore.states.split(",").map((s) => s.trim())
                : [],
              total_clients: fetchedDataStore.total_clients || "",
              total_units: fetchedDataStore.total_units || "",
              services: fetchedDataStore.services || [],
              permissions: [],
              validity_start_date: fetchedDataStore.validity_start_date
                ? new Date(fetchedDataStore.validity_start_date).toISOString().slice(0, 10)
                : "",
              validity_end_date: fetchedDataStore.validity_end_date
                ? new Date(fetchedDataStore.validity_end_date).toISOString().slice(0, 10)
                : "",
            };

            setCompanyDetails(mergedDetails);

            const selectedStatesArray = Array.isArray(fetchedDataStore.states)
              ? fetchedDataStore.states
              : typeof fetchedDataStore.states === "string"
              ? fetchedDataStore.states.split(",").map((s) => s.trim())
              : [];

            setSelectedStates(selectedStatesArray);
            setPreSelectedPermissions({ permissions: fetchedDataStore.permissions || [] });

            setLoading(false);
          } else {
            setLoading(false);
          }
        } catch (error) {
          setLoading(false);
          console.error("Failed to fetch company details:", error);
        }
      };

    useEffect(() => {
        fetchcompanyDetails();

    }, [dispatch]);

    // useEffect(() => {
    //     if (!preSelectedPermissions.permissions) return;

    //     let parsedPermissions = [];

    //     if (
    //       Array.isArray(preSelectedPermissions.permissions) &&
    //       typeof preSelectedPermissions.permissions[0] === "string"
    //     ) {
    //       try {
    //         parsedPermissions = JSON.parse(preSelectedPermissions.permissions[0]);
    //       } catch (e) {
    //         console.error("❌ Failed to parse permissions[0]", e);
    //         return;
    //       }
    //     }
    //     // Case 2: normal array of objects
    //     else if (Array.isArray(preSelectedPermissions.permissions)) {
    //       parsedPermissions = preSelectedPermissions.permissions;
    //     }
    //     // Case 3: single string
    //     else if (typeof preSelectedPermissions.permissions === "string") {
    //       try {
    //         parsedPermissions = JSON.parse(preSelectedPermissions.permissions);
    //       } catch (e) {
    //         console.error("❌ Failed to parse permissions string", e);
    //         return;
    //       }
    //     } else {
    //       return;
    //     }

    //     const newSelectedServices = [];
    //     const newSelectedSections = {};
    //     const newSelectedSubModules = {};
    //     const newCrudPermissions = {};
    //     parsedPermissions.forEach((perm) => {
    //       const service = perm.service;
    //       const section = perm.section;
    //       const module = perm.module;
    //       const moduleKey = `${service}-${module}`;
    //       if (!newSelectedServices.includes(service)) {
    //         toggleServiceExpand(service);
    //       }
    //       newSelectedServices[service] = true;
    //       newSelectedSections[moduleKey] = true;

    //       if (Array.isArray(perm.sub_module)) {
    //         perm.sub_module.forEach((sub) => {
    //           const subKey = `${service}-${module}-${sub.name}`;
    //           newSelectedSubModules[subKey] = true;

    //           newCrudPermissions[subKey] = {
    //             create: sub.action?.create || false,
    //             edit: sub.action?.edit || false,
    //             delete: sub.action?.delete || false,
    //           };
    //         });
    //       } else if (typeof perm.action === "object") {
    //         newCrudPermissions[moduleKey] = {
    //           create: perm.action?.create || false,
    //           edit: perm.action?.edit || false,
    //           delete: perm.action?.delete || false,
    //         };
    //       }
    //     });

    //     setSelectedServices(newSelectedServices);
    //     setSelectedSections(newSelectedSections);
    //     setSelectedSubModules(newSelectedSubModules);
    //     setCrudPermissions(newCrudPermissions);
    //     toggleServiceExpand(newSelectedServices);

    //   }, [preSelectedPermissions.permissions]);

    useEffect(() => {
        if (!preSelectedPermissions.permissions) return;

        let parsedPermissions = [];

        if (
          Array.isArray(preSelectedPermissions.permissions) &&
          typeof preSelectedPermissions.permissions[0] === "string"
        ) {
          try {
            parsedPermissions = JSON.parse(preSelectedPermissions.permissions[0]);
          } catch (e) {
            console.error("❌ Failed to parse permissions[0]", e);
            return;
          }
        } else if (Array.isArray(preSelectedPermissions.permissions)) {
          parsedPermissions = preSelectedPermissions.permissions;
        } else if (typeof preSelectedPermissions.permissions === "string") {
          try {
            parsedPermissions = JSON.parse(preSelectedPermissions.permissions);
          } catch (e) {
            console.error("❌ Failed to parse permissions string", e);
            return;
          }
        } else {
          return;
        }

        const newSelectedServices = {};
        const newSelectedSections = {};
        const newSelectedSubModules = {};
        const newCrudPermissions = {};

        parsedPermissions.forEach((perm) => {
          const service = perm.service;
          const module = perm.module;
          const moduleKey = `${service}-${module}`;

          if (!newSelectedServices[service]) {
            toggleServiceExpand(service); // ✅ correct per-service expand
            newSelectedServices[service] = true;
          }

          newSelectedSections[moduleKey] = true;

          if (Array.isArray(perm.sub_module)) {
            perm.sub_module.forEach((sub) => {
              const subKey = `${service}-${module}-${sub.name}`;
              newSelectedSubModules[subKey] = true;

              newCrudPermissions[subKey] = {
                create: sub.action?.create || false,
                edit: sub.action?.edit || false,
                delete: sub.action?.delete || false,
              };
            });
          } else if (typeof perm.action === "object") {
            newCrudPermissions[moduleKey] = {
              create: perm.action?.create || false,
              edit: perm.action?.edit || false,
              delete: perm.action?.delete || false,
            };
          }
        });

        setSelectedServices(newSelectedServices);
        setSelectedSections(newSelectedSections);
        setSelectedSubModules(newSelectedSubModules);
        setCrudPermissions(newCrudPermissions);

      }, [preSelectedPermissions.permissions]);



    const handleFetchStates = async () => {
        try {
        const response = await dispatch(getStates());
        setState(response.data.states);
        } catch (err) {
        console.error("Failed to fetch states:", err);
        }
    };
    const handleFetchPermission = async () => {
        try {
        const response = await dispatch(getPermission());
        setAllPermission(response.data[0].permissions);
        } catch (err) {
        console.error("Failed to fetch states:", err);
        }
    };
    const fetchUser = async () => {

        try {
            const response = await dispatch(getUser(CompanyID));
            // setAllPermission(response.data[0].permissions);
            if (response.data) {
                const getFetchedSuperAdmin =response.data?.filter((data => data.role_name === "Organization Admin"))[0];
                const mergedUserData = {
                    auth_id:getFetchedSuperAdmin.auth_id,
                    user_name: getFetchedSuperAdmin.user_name,
                    user_email: getFetchedSuperAdmin.user_email,
                    role_name: "Organization Admin",
                    mail_sent:getFetchedSuperAdmin.mail_sent

                }
                setUserDetails(mergedUserData);

            }
            } catch (err) {
            console.error("Failed to fetch states:", err);
            }
    }

    const fetchRole = async () => {

        try {
            const response = await dispatch(getCompanyRole(CompanyID));
            if (response.data) {
                const getFetchedSuperAdminRole =response.data?.filter((data => data.base_role === "SuperAdmin"))[0];
                getRoleId(getFetchedSuperAdminRole.id);

            }
            } catch (err) {
            console.error("Failed to fetch states:", err);
            }
    }
    useEffect(() => {
        handleFetchStates();
        handleFetchPermission();
        fetchUser();
        fetchRole()
    }, [dispatch]);
    const handleCheckboxChange = (stateItem) => {
        if (!stateItem || !stateItem.state_name) return;

        const updatedSelectedStates = ((prevSelected) => {
        const isSelected = prevSelected.includes(stateItem.state_name);
        return isSelected
            ? prevSelected.filter((name) => name !== stateItem.state_name)
            : [...prevSelected, stateItem.state_name];
        })(selectedStates);
        setSelectedStates(updatedSelectedStates);
        setCompanyDetails(prev => ({
            ...prev,
            states: updatedSelectedStates,
        }));
    };
    const handleCompanyChange = (e) => {
        const { name, value, multiple, options, type } = e.target;

        if (multiple) {
          const selected = Array.from(options)
            .filter(option => option.selected)
            .map(option => option.value);

          setCompanyDetails(prev => ({
            ...prev,
            [name]: selected,
          }));

          setCompanyErrors(prev => ({
            ...prev,
            [name]: "",
          }));
        } else {
          let newValue = value;

          if (type === 'number' && value !== '') {
            newValue = Number(value);
          }

          setCompanyDetails(prev => ({
            ...prev,
            [name]: newValue,
          }));

          setCompanyErrors(prev => ({
            ...prev,
            [name]: "",
          }));
        }
      };


    const serviceOptions = [
        { value: "Registers", label: "Registers" },
        { value: "Audit", label: "Audit" },
        // { value: "Complaince", label: "Complaince" },
    ];
    const handleServicesChange = (selectedOptions) => {
        setCompanyDetails(prev => ({
          ...prev,
          services: selectedOptions.map(opt => opt.value),
        }));

        setCompanyErrors(prev => ({
          ...prev,
          Services: "",
        }));
      };

    const handleUserChange = (e) => {
        const { name, value } = e.target;
        setUserDetails({ ...userDetails, [name]: value });
        setUserErrors({ ...userErrors, [name]: "" });
    };
    const validateCompanyDetails = () => {
        const errors = {};
        if (!companyDetails.company_name) errors.company_name = "Company name is required";
        if (!companyDetails.company_address) errors.company_address = "company address is required";
        if (!companyDetails.company_city) errors.company_city = "company city is required";
        if (!companyDetails.company_state) errors.company_state = " company state required";
        if (!companyDetails.company_country) errors.company_country = "company country required";
        if (!companyDetails.company_pincode) errors.company_pincode = " company pincode is required";
        if (!companyDetails.company_mail) errors.company_mail = "company mail is required";
        if (!companyDetails.company_phone) errors.company_phone = "company phone is required";
        if (!companyDetails.company_mobile) errors.company_mobile = " company mobile is required";
        if (!companyDetails.company_url) errors.company_url = "company url is required";
        if (!companyDetails.company_logo) errors.company_logo = "company logo is required";
        if (!companyDetails.total_clients) errors.total_clients = "Total clients is required";
        if (!companyDetails.total_units) errors.total_units = "Total units is required";
        if (!companyDetails.validity_start_date) errors.validity_start_date = "Validity start date is required";
        if (!companyDetails.validity_end_date) errors.validity_end_date = "Validity end date is required";
        if (companyDetails.services.length === 0) {
            errors.Services = "Please select at least one service";
        }

        setCompanyErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const validateSelectedStates = () => {
        if (selectedStates.length == 0) {
        setStateErrors("Please select at least one state");
        return false;
        }
        setStateErrors("");
        return true;
    };
    const validatePermission = () => {
        if (JSON.stringify(permissionPayload).length < 10) {
            setPermissionErrors("Please give permission");
        return false;
        }else{
            setPermissionErrors();
        }
        setStateErrors("");
        return true;
    };
    const validateUserDetails = () => {
        const errors = {};
        if (!userDetails.user_name) errors.user_name = "Username is required";
        if (!userDetails.user_email) errors.user_email = "Mail ID is required";
        setUserErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        validateCompanyDetails()
        validateSelectedStates()
        validateUserDetails()
        validatePermission()
        const isCompanyValid = validateCompanyDetails();
        const isStatesValid = validateSelectedStates();
        const isUserValid = validateUserDetails();
        const isPermissionValid = validatePermission();

        if (!isCompanyValid || !isStatesValid || !isUserValid || !isPermissionValid) {
          return;
        }

        setTimeout(() => {
          createCompanyDetails();
        }, 500);
      };

  const createCompanyDetails = async () => {
    const finalPermissions = [JSON.stringify(permissionPayload)];
    const finalData = {
      ...companyDetails,
      permissions: finalPermissions,
    };


    const dataresponse = await dispatch(updateCompanyDetailsById(finalData.id, finalData));

    if (dataresponse.success === true) {
    const getPermittedData = {
        permissions:finalPermissions,
        role_name:"Organization Admin"
    }
    const responseRole = await dispatch(updateRoleById(roleId,getPermittedData));
      const storeUserData = await dispatch(updateUserById(userDetails.auth_id, userDetails));
      console.log(userDetails);
      
      if (storeUserData.success === true) {
        // showSnackbar(storeUserData.message, 'success');
        navigate('/company-details', {
            state: {
              snackbar: {
                message: storeUserData.message,
                severity: 'success',
              }
            }
          });
      } else {
        showSnackbar(storeUserData.message, 'error');
      }

      setLoading(false);
    } else {
      showSnackbar(dataresponse.message, 'error');
      setLoading(false);
    }
  };



const handleCheckbox = (setter, key, service) => {
    setter((prev) => {
      const isChecked = !prev[key];
      const updated = { ...prev, [key]: isChecked };

      if (setter === setSelectedServices && service && !isChecked) {
        const filtered = allPermission.filter((mod) => mod.service === service);

        const moduleClear = {};
        const subModuleClear = {};
        const crudClear = {};

        filtered.forEach((mod) => {
          const moduleKey = `${mod.service}-${mod.module}`;
          moduleClear[moduleKey] = false;

          if (Array.isArray(mod.sub_module) && mod.sub_module.length > 0) {
            mod.sub_module.forEach((sub) => {
              const subKey = `${mod.service}-${mod.module}-${sub.name}`;
              subModuleClear[subKey] = false;
              crudClear[subKey] = { create: false, edit: false, delete: false };
            });
          } else {
            if (mod.action === "Yes") {
              crudClear[moduleKey] = { create: false, edit: false, delete: false };
            }
          }
        });

        setSelectedSections((prev) => ({ ...prev, ...moduleClear }));
        setSelectedSubModules((prev) => ({ ...prev, ...subModuleClear }));
        setCrudPermissions((prev) => ({ ...prev, ...crudClear }));
        setExpandedServices((prev) => ({ ...prev, [service]: false }));
      }

      return updated;
    });
  };

  const handleCrudToggle = (key, action) => {
    setCrudPermissions((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [action]: !prev[key]?.[action],
      },
    }));
  };

  const toggleServiceExpand = (serviceName) => {
    setExpandedServices((prev) => ({
      ...prev,
      [serviceName]: !prev[serviceName],
    }));
  };
  const uniqueServices = [...new Set(allPermission.map((item) => item.service))];
const handleAllInService = (service) => {
    const isCurrentlyChecked = computeAllServiceChecked(service);

    const filtered = allPermission.filter((mod) => mod.service === service);
    const updates = {};
    const subModuleUpdates = {};
    const crudUpdate = {};

    filtered.forEach((mod) => {
      const moduleKey = `${mod.service}-${mod.module}`;
      updates[moduleKey] = !isCurrentlyChecked;

      if (Array.isArray(mod.sub_module) && mod.sub_module.length > 0) {
        mod.sub_module.forEach((sub) => {
          const subKey = `${mod.service}-${mod.module}-${sub.name}`;
          subModuleUpdates[subKey] = !isCurrentlyChecked;
          if (mod.action === "Yes") {
            crudUpdate[subKey] = {
              create: !isCurrentlyChecked,
              edit: !isCurrentlyChecked,
              delete: !isCurrentlyChecked,
            };
          }
        });
      } else {
        if (mod.action === "Yes") {
          crudUpdate[moduleKey] = {
            create: !isCurrentlyChecked,
            edit: !isCurrentlyChecked,
            delete: !isCurrentlyChecked,
          };
        }
      }
    });

    setSelectedSections((prev) => ({ ...prev, ...updates }));
    setSelectedSubModules((prev) => ({ ...prev, ...subModuleUpdates }));
    setCrudPermissions((prev) => ({ ...prev, ...crudUpdate }));

  };


  const groupBy = (arr, key) =>
  arr.reduce((acc, obj) => {
    const group = obj[key] || "Others";
    acc[group] = acc[group] || [];
    acc[group].push(obj);
    return acc;
  }, {});

  const getPermissionJson = () => {
    const result = [];

    Object.keys(selectedSections).forEach((modKey) => {
      if (!selectedSections[modKey]) return;

      const [service, module] = modKey.split("-");
      const modEntry = allPermission.find((m) => m.service === service && m.module === module);
      if (!modEntry) return;

      const hasSubModules = Array.isArray(modEntry.sub_module) && modEntry.sub_module.length > 0;

      if (hasSubModules) {
        const sub_module = modEntry.sub_module
          .map((sub) => {
            const key = `${modEntry.service}-${modEntry.module}-${sub.name}`;
            if (!selectedSubModules[key]) return null;

            return {
              name: sub.name,
              action: {
                create: !!crudPermissions[key]?.create,
                edit: !!crudPermissions[key]?.edit,
                delete: !!crudPermissions[key]?.delete,
              },
            };
          })
          .filter(Boolean);

        if (sub_module.length > 0) {
          result.push({
            service: modEntry.service,
            section: modEntry.section,
            module: modEntry.module,
            action: "Yes",
            sub_module,
          });
        }
      } else {
        result.push({
          service: modEntry.service,
          section: modEntry.section,
          module: modEntry.module,
          action: {
            create: !!crudPermissions[modKey]?.create,
            edit: !!crudPermissions[modKey]?.edit,
            delete: !!crudPermissions[modKey]?.delete,
          },
        });
      }
    });

    return result;
  };

  const permissionPayload = getPermissionJson();

  const computeAllServiceChecked = (service) => {
    const filtered = allPermission.filter((mod) => mod.service === service);

    for (let mod of filtered) {
      const moduleKey = `${mod.service}-${mod.module}`;
      if (!selectedSections[moduleKey]) return false;

      if (Array.isArray(mod.sub_module) && mod.sub_module.length > 0) {
        for (let sub of mod.sub_module) {
          const subKey = `${mod.service}-${mod.module}-${sub.name}`;
          if (!selectedSubModules[subKey]) return false;

          if (mod.action === "Yes") {
            const crud = crudPermissions[subKey] || {};
            if (!(crud.create && crud.edit && crud.delete)) return false;
          }
        }
      } else {
        if (mod.action === "Yes") {
          const crud = crudPermissions[moduleKey] || {};
          if (!(crud.create && crud.edit && crud.delete)) return false;
        }
      }
    }

    return true;
  };


  return (
    <div  className="container-fluid windown-min-height" >
        <div className="col-md-12 py-3">
            <div className="card m-3 shadow">
                <div className="card-header card-header-color py-2 bg-light">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                        <h6 className="text-dark mb-0">Company Details ({CompanyID})</h6>
                        </div>
                        <div className="col-md-6 text-end">
                            <a href="/company-details" className="text-dark">
                                <i className="bi bi-x fs-4 cancel-icon"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="col-md-12">
                        <form onSubmit={handleSubmit} className="p-4 border rounded">
                            <div className='border border-1 rounded p-3 mt-2'>
                                <div className="row">
                                    <div className="col-md-12">
                                    <h5>Basic details of the company</h5>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label>Company Name <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_name"
                                            className={`form-control ${companyErrors.company_name ? "border-danger" : ""}`}
                                            value={companyDetails.company_name}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_name && (
                                            <small className="text-danger">{companyErrors.company_name}</small>
                                        )}
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label>Company Address<span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_address"
                                            className={`form-control ${companyErrors.company_address ? "border-danger" : ""}`}
                                            value={companyDetails.company_address}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_address && (
                                            <small className="text-danger">{companyErrors.company_address}</small>
                                        )}
                                    </div>

                                    <div className="col-md-3 mb-3">
                                    <label>company City <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_city"
                                            className={`form-control ${companyErrors.company_city ? "border-danger" : ""}`}
                                            value={companyDetails.company_city}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_city && (
                                            <small className="text-danger">{companyErrors.company_city}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>company State <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_state"
                                            className={`form-control ${companyErrors.company_state ? "border-danger" : ""}`}
                                            value={companyDetails.company_state}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_state && (
                                            <small className="text-danger">{companyErrors.company_state}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>company Country <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_country"
                                            className={`form-control ${companyErrors.company_country ? "border-danger" : ""}`}
                                            value={companyDetails.company_country}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_country && (
                                            <small className="text-danger">{companyErrors.company_country}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Company Pincode <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_pincode"
                                            className={`form-control ${companyErrors.company_pincode ? "border-danger" : ""}`}
                                            value={companyDetails.company_pincode}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_pincode && (
                                            <small className="text-danger">{companyErrors.company_pincode}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Company Mail <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_mail"
                                            className={`form-control ${companyErrors.company_mail ? "border-danger" : ""}`}
                                            value={companyDetails.company_mail}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_mail && (
                                            <small className="text-danger">{companyErrors.company_mail}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Company Phone <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_phone"
                                            className={`form-control ${companyErrors.company_phone ? "border-danger" : ""}`}
                                            value={companyDetails.company_phone}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_phone && (
                                            <small className="text-danger">{companyErrors.company_phone}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Company Mobile <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_mobile"
                                            className={`form-control ${companyErrors.company_mobile ? "border-danger" : ""}`}
                                            value={companyDetails.company_mobile}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_mobile && (
                                            <small className="text-danger">{companyErrors.company_mobile}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Company url <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="company_url"
                                            className={`form-control ${companyErrors.company_url ? "border-danger" : ""}`}
                                            value={companyDetails.company_url}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.company_url && (
                                            <small className="text-danger">{companyErrors.company_url}</small>
                                        )}
                                    </div>
                                    {/* <div className="col-md-3 mb-3">
                                    <label>Company Logo <span className='text-danger'>*</span></label>
                                        <input
                                            type="file"
                                            name="company_logo"
                                            className={`form-control ${companyErrors.company_logo ? "border-danger" : ""}`}
                                            value={companyDetails.company_logo}
                                            onChange={handleCompanyChange}
                                            accept=".png,.jpg,.jpeg"
                                        />
                                        {companyErrors.company_logo && (
                                            <small className="text-danger">{companyErrors.company_logo}</small>
                                        )}
                                    </div> */}
                                    <div className="col-md-3 mb-3">
                                    <label>Validity Start Date <span className='text-danger'>*</span></label>
                                        <input
                                            type="date"
                                            name="validity_start_date"
                                            className={`form-control ${companyErrors.validity_start_date ? "border-danger" : ""}`}
                                            value={companyDetails.validity_start_date}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.validity_start_date && (
                                            <small className="text-danger">{companyErrors.validity_start_date}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Validity End Date <span className='text-danger'>*</span></label>
                                        <input
                                            type="date"
                                            name="validity_end_date"
                                            className={`form-control ${companyErrors.validity_end_date ? "border-danger" : ""}`}
                                            value={companyDetails.validity_end_date}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.validity_end_date && (
                                            <small className="text-danger">{companyErrors.validity_end_date}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label>Services <span className='text-danger'>*</span></label>
                                        <Select
                                            options={serviceOptions}
                                            isMulti
                                            isSearchable
                                            value={serviceOptions.filter(opt => companyDetails.services.includes(opt.value))}
                                            onChange={handleServicesChange}
                                            classNamePrefix="react-select"
                                            className={companyErrors.Services ? "border-danger" : ""}
                                            placeholder="Select services"
                                        />
                                        {companyErrors.Services && (
                                            <small className="text-danger">{companyErrors.Services}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Total Clients <span className='text-danger'>*</span></label>
                                        <input
                                            type="number"
                                            name="total_clients"
                                            className={`form-control ${companyErrors.total_clients ? "border-danger" : ""}`}
                                            value={companyDetails.total_clients}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.total_clients && (
                                            <small className="text-danger">{companyErrors.total_clients}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                    <label>Total Units <span className='text-danger'>*</span></label>
                                        <input
                                            type="number"
                                            name="total_units"
                                            className={`form-control ${companyErrors.total_units ? "border-danger" : ""}`}
                                            value={companyDetails.total_units}
                                            onChange={handleCompanyChange}
                                        />
                                        {companyErrors.total_units && (
                                            <small className="text-danger">{companyErrors.total_units}</small>
                                        )}
                                    </div>


                                </div>
                            </div>

                            <div className='border border-1 rounded p-3 mt-2'>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>States Access</h5>
                                    </div>
                                        <div className="col-md-12 text-danger">
                                            <h5>{stateErrors}</h5>
                                        </div>
                                </div>
                                <hr />
                            <div className="row">
                            {Array.isArray(State) && State.length > 0 ? (
                                State.map((state) =>
                                    state ? (
                                        <div className="col-md-4 mb-2" key={state.state_name}>
                                            <div className="form-check">
                                                <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`state-${state.state_name}`}
                                                checked={selectedStates.includes(state.state_name)}
                                                onChange={() => handleCheckboxChange(state)}
                                                />
                                                <label className="form-check-label" htmlFor={`state-${state.state_name}`}>
                                                {state.state_name}
                                                </label>
                                            </div>
                                        </div>
                                    ) : null
                                )
                                ) : (
                                <p>No states available</p>
                                )}

                            </div>
                            </div>

                            <div className='border border-1 rounded p-3 mt-2'>

                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>Organization Admin</h5>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label>User Name <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="user_name"
                                            className={`form-control ${userErrors.user_name ? "border-danger" : ""}`}
                                            value={userDetails.user_name}
                                            onChange={handleUserChange}
                                        />
                                        {userErrors.user_name && (
                                            <small className="text-danger">{userErrors.user_name}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label>Mail Id <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            name="user_email"
                                            className={`form-control ${userErrors.user_email ? "border-danger" : ""}`}
                                            value={userDetails.user_email}
                                            onChange={handleUserChange}
                                        />
                                        {userErrors.user_email && (
                                            <small className="text-danger">{userErrors.user_email}</small>
                                        )}
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label>Role Name</label>
                                        <input type="tel" className="form-control" value="Organization Admin"   readOnly/>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label>Mail notification <span className='text-danger'>*</span></label>
                                        <select name="mail_sent" className={`form-control ${userErrors.mail_sent ? "border-danger" : ""}`} id="" value={userDetails.mail_sent}
                                            onChange={handleUserChange}>
                                            <option value="1"checked={userDetails.mail_sent == 1 && true}>Yes</option>
                                            <option value="0"checked={userDetails.mail_sent == 0 && true} >No</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className='border border-1 rounded p-3 mt-2'>
                                <div className="row">
                                    <div className="col-md-12">
                                    <h5>Permission</h5>
                                    </div>
                                        <div className="col-md-12 text-danger">
                                            <h5>{permissionErrors}</h5>
                                        </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <table className="table table-bordered align-middle text-nowrap">
                                        <thead className="table-light text-center">
                                            <tr>
                                            <th style={{ width: "40%" }}>Section / Module / Submodule</th>
                                            <th>Create</th>
                                            <th>Edit</th>
                                            <th>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {uniqueServices.map((service) => (
                                            <React.Fragment key={service}>
                                                <tr className="table-primary">
                                                <td colSpan={4}>
                                                    <label className="fw-bold" style={{ cursor: "pointer" }}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        checked={!!selectedServices[service]}
                                                        onClick={() => {
                                                            toggleServiceExpand(service);
                                                            handleCheckbox(setSelectedServices, service, service); // <-- pass service as both key & service
                                                        }}

                                                    />
                                                    {service}
                                                    </label>
                                                    <label className="fw-bold">
                                                    <input
                                                    type="checkbox"
                                                    className="form-check-input me-2 ms-3"
                                                    // checked={!!allServiceChecked[service]}
                                                    checked={computeAllServiceChecked(service)}
                                                    disabled={!selectedServices[service]}
                                                    onChange={() => handleAllInService(service)}
                                                    />All in {service}</label>

                                                </td>
                                                </tr>

                                                {expandedServices[service] &&
                                                Object.entries(
                                                    groupBy(
                                                    allPermission.filter((mod) => mod.service === service),
                                                    "section"
                                                    )
                                                ).map(([section, mods]) => (
                                                    <React.Fragment key={section}>
                                                    <tr className="">
                                                        <td colSpan={4} style={{ paddingLeft: "15px" }}>
                                                        <strong>{section.toUpperCase()}</strong>
                                                        </td>
                                                    </tr>

                                                    {mods.map((mod) => {
                                                        const moduleKey = `${mod.service}-${mod.module}`;
                                                        const hasSubModules =
                                                        Array.isArray(mod.sub_module) &&
                                                        mod.sub_module.length > 0;

                                                        return (
                                                        <React.Fragment key={mod.module}>
                                                            <tr className="table-secondary">
                                                            <td colSpan={4} style={{ paddingLeft: "20px" }}>
                                                                <label>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input me-2"
                                                                    checked={!!selectedSections[moduleKey]}
                                                                    onChange={() =>
                                                                    handleCheckbox(
                                                                        setSelectedSections,
                                                                        moduleKey,
                                                                        mod.service
                                                                    )
                                                                    }
                                                                />
                                                                <strong>{mod.module}</strong>
                                                                </label>
                                                            </td>
                                                            </tr>

                                                            {selectedSections[moduleKey] &&
                                                            (hasSubModules ? (
                                                                mod.sub_module.map((sub) => {
                                                                const key = `${mod.service}-${mod.module}-${sub.name}`;
                                                                const showCRUD =
                                                                    selectedSubModules[key] &&
                                                                    mod.action === "Yes";

                                                                return (
                                                                    <tr key={key}>
                                                                    <td style={{ paddingLeft: "40px" }}>
                                                                        <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input me-2"
                                                                            checked={!!selectedSubModules[key]}
                                                                            onChange={() =>
                                                                            handleCheckbox(
                                                                                setSelectedSubModules,
                                                                                key,
                                                                                mod.service
                                                                            )
                                                                            }
                                                                        />
                                                                        {sub.name}
                                                                        </label>
                                                                    </td>
                                                                    {["create", "edit", "delete"].map((action) => (
                                                                        <td key={action} className="text-center">
                                                                        {showCRUD && (
                                                                            <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            checked={
                                                                                !!crudPermissions[key]?.[action]
                                                                            }
                                                                            onChange={() =>
                                                                                handleCrudToggle(key, action)
                                                                            }
                                                                            />
                                                                        )}
                                                                        </td>
                                                                    ))}
                                                                    </tr>
                                                                );
                                                                })
                                                            ) : (
                                                                mod.action === "Yes" && (
                                                                <tr key={`no-sub-${mod.module}`}>
                                                                    <td style={{ paddingLeft: "40px" }}>
                                                                    {mod.module}
                                                                    </td>
                                                                    {["create", "edit", "delete"].map((action) => (
                                                                    <td key={action} className="text-center">
                                                                        <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={
                                                                            !!crudPermissions[moduleKey]?.[action]
                                                                        }
                                                                        onChange={() =>
                                                                            handleCrudToggle(moduleKey, action)
                                                                        }
                                                                        />
                                                                    </td>
                                                                    ))}
                                                                </tr>
                                                                )
                                                            ))}
                                                        </React.Fragment>
                                                        );
                                                    })}
                                                    </React.Fragment>
                                                ))}
                                            </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>


                            <div className="d-flex mt-4 float-end">
                                <button type="submit" className="btn btn-success  m-3 btn-sm">
                                    Update
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default UpdateCompanyDetails
